import { ChakraV3 } from '@piccolohealth/ui';
import { z } from '@piccolohealth/util';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { HookedFormField } from '../../../components/forms/HookedFormField';
import { HookedPinInput } from '../../../components/forms/HookedPinInput';
import { HookedSubmitButton } from '../../../components/forms/V3HookedSubmitButton';
import { zodResolver } from '../../../utils/zod';
import { AuthCard } from './AuthCard';
import { AuthLayout } from './AuthLayout';
import { MFAChooseMethodButton } from './MFAChooseMethodButton';

type FormValues = {
  verificationCode: string;
};

const schema: z.ZodSchema<FormValues> = z.object({
  verificationCode: z.string().length(6).length(6, 'Verification code must be 6 characters'),
});

interface Props {
  onVerifyCode: (verificationCode: string) => Promise<void>;
}

export const TotpVerifyCard = (props: Props) => {
  const methods = useForm<FormValues>({
    defaultValues: {
      verificationCode: '',
    },
    resolver: zodResolver(schema),
  });

  const onVerifyCode = async (values: FormValues) => {
    return props.onVerifyCode(values.verificationCode).catch(() => {
      methods.setError('verificationCode', {
        message: 'Invalid verification code',
      });
      methods.resetField('verificationCode', {
        keepError: true,
      });
    });
  };

  return (
    <AuthLayout>
      <AuthCard>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Text fontWeight='semibold' fontSize='2xl'>
            Two-factor Authentication
          </ChakraV3.Text>
          <ChakraV3.Text fontSize='sm' color='secondary'>
            Enter the verification code in your authenticator app
          </ChakraV3.Text>
        </ChakraV3.Stack>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onVerifyCode)}>
            <ChakraV3.Stack gap={4}>
              <HookedFormField name='verificationCode'>
                <ChakraV3.Stack align='center'>
                  <HookedPinInput name='verificationCode' fieldCount={6} />
                </ChakraV3.Stack>
              </HookedFormField>

              <HookedSubmitButton size='md' mt={4} disabled={false} loadingText='Verifying...'>
                Verify
              </HookedSubmitButton>
            </ChakraV3.Stack>
          </form>
        </FormProvider>
        <MFAChooseMethodButton />
      </AuthCard>
    </AuthLayout>
  );
};
